import styled from "@emotion/styled";
import { Box, TableRow } from "@mui/material";

export const FlexTableContainer = styled(Box)`
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
`;

export const FlexTableHeader = styled("div")`
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  ${({ theme }) => theme.media.tabletSm} {
    display: none;
  }
`;

export const FlexHeaderCell = styled("div")<{
  width?: number;
  flex?: number;
  align?: "left" | "center" | "right";
}>`
  padding: 12px 24px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => align || "flex-start"};
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  ${({ width }) => width && `width: ${width}px;`}
  ${({ flex }) => flex && `flex: ${flex};`}
  ${({ theme }) => theme.media.tabletSm} {
    display: none;
    border-bottom: none;
  }
`;

export const FlexTableRow = styled("div")<{
  isHighlighted?: boolean;
  height?: number;
}>`
  display: flex;
  ${({ height }) => `height: ${height ? height : 52}px;`}
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background-color: ${({ isHighlighted }) =>
    isHighlighted ? "rgba(25, 118, 210, 0.08)" : "transparent"};

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const FlexTableCell = styled("div")<{
  width?: number;
  flex?: number;
  align?: "left" | "center" | "right";
}>`
  padding: 16px 24px;
  font-size: 14px;
  display: flex;
  align-items: center;
  letter-spacing: -0.4px;
  justify-content: ${({ align }) => align || "flex-start"}; // 기본값은 left
  color: rgba(0, 0, 0, 0.87);
  ${({ width }) => width && `width: ${width}px;`}
  ${({ flex }) => flex && `flex: ${flex};`}
`;

export const NoPostsText = styled.p`
  width: 100%;
  height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid var(--divider, #0000001f);
  opacity: 1;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.4px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--text-secondary, #00000099);

  margin: 0;
`;

export const ResponsiveTable = styled.div<{
  isHighlighted?: boolean;
  height?: number;
}>`
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  background-color: ${({ isHighlighted }) =>
    isHighlighted ? "rgba(25, 118, 210, 0.08)" : "transparent"};
  &:hover {
    background: ${({ theme }) => theme.colors.brand.white.hover};
  }

  .font-s {
    font-size: 12px;
  }
  .font-md {
    font-size: 16px;
  }
  .pr {
    padding-right: 4px;
  }
`;

export const StyledTableRow = styled(TableRow)`
  ${({ theme }) => theme.typography.body2.m}
  .qna {
    ${({ theme }) => theme.typography.body1.m};
    span {
      color: ${({ theme }) => theme.colors.text.medium.black};
    }
  }
  cursor: pointer;
  display: flex;
  gap: 4px;
  &:hover {
    background: ${({ theme }) => theme.colors.brand.white.hover};
  }
`;

export const InquiryTypeText = styled.span`
  ${({ theme }) => theme.typography.body2.m}
  color: ${({ theme }) => theme.colors.text.medium.black};
  padding-right: 2px;
`;
